import { render, staticRenderFns } from "./x-extra-params.component.vue?vue&type=template&id=998e08fc"
import script from "./x-extra-params.component.vue?vue&type=script&lang=ts"
export * from "./x-extra-params.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports